import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Money from '../money';
import Text from '../text';
import Icon from '../icon';
import PopupTooltip from '../../overlays/popupTooltip';
import classnames from 'classnames/bind';
import { match } from 'ts-pattern';
import styles from './styles.scss';
import { ColorNames } from '../../../constants';
const cx = classnames.bind(styles);
const Tooltip = ({ content, iconStyle, onMouseOver, onMouseOut, }) => (_jsx(PopupTooltip, { content: content, wide: false, trigger: _jsx(Icon, { size: 'small', color: 'gray', name: 'info-circle', fitted: true, style: { verticalAlign: 'super' }, iconStyle: iconStyle, onMouseOver: onMouseOver, onMouseOut: onMouseOut }) }));
const LabelValue = ({ value, label, level = 3, isMoneyValue, hideDecimals = false, href, tooltipContent, tooltipIconStyle = 'solid', elmId = '', classNames = {}, infoPill = undefined, onTooltipMouseOver, onTooltipMouseOut, }) => {
    const props = match(level)
        .with(1, () => ({
        label: { color: 'grayMedium', size: 'large', weight: 'black' },
        value: { color: 'gray', size: 'massive', weight: 'black' },
    }))
        .with(2, () => ({
        label: { color: 'grayMedium', size: 'small', weight: 'heavy' },
        value: { color: 'gray', size: 'big', weight: 'black' },
    }))
        .with(3, () => ({
        label: { color: 'gray', size: 'small', weight: 'normal' },
        value: { color: 'gray', size: 'small', weight: 'black' },
    }))
        .with(4, () => ({
        label: { color: 'grayMedium', size: 'tiny', weight: 'normal' },
        value: { color: 'gray', size: 'tiny', weight: 'black' },
    }))
        .with(5, () => ({
        label: { color: 'grayMedium', size: 'small', weight: 'normal' },
        value: { color: 'gray', size: 'big', weight: 'black' },
    }))
        .with(6, () => ({
        label: { color: 'gray', size: 'small', weight: 'normal' },
        value: { color: 'success', size: 'small', weight: 'black' },
    }))
        .with(7, () => ({
        label: { color: 'gray', size: 'small', weight: 'normal' },
        value: { color: 'caution', size: 'small', weight: 'black' },
    }))
        .otherwise(() => ({
        label: { color: 'gray', size: 'small', weight: 'normal' },
        value: { color: 'gray', size: 'small', weight: 'black' },
    }));
    let specialLabel = isMoneyValue ? (_jsx(Money, { elmId: elmId ? `${elmId}-value` : 'value', className: cx('value', `value-${level}`, classNames.value), amount: typeof value === 'string' ? parseFloat(value) : value, ...props.value, infoPill: infoPill, overrides: {
            minimumFractionDigits: hideDecimals ? 0 : 2,
        }, hideDecimals: hideDecimals })) : null;
    if (href) {
        specialLabel = (_jsx("a", { href: href, target: '_blank', children: _jsx(Text, { elmId: elmId ? `${elmId}-value` : 'value', weight: 'black', color: ColorNames.Info, className: cx('link-value'), children: value }) }));
    }
    return (_jsxs("div", { children: [_jsxs(Text, { ...props.label, elmId: elmId ? `${elmId}-label` : 'label', className: cx('label', `label-${level}`, classNames.label), children: [label, tooltipContent && (_jsx("span", { className: 'u-ml-1', children: _jsx(Tooltip, { content: tooltipContent, iconStyle: tooltipIconStyle, onMouseOver: onTooltipMouseOver, onMouseOut: onTooltipMouseOut }) }))] }), specialLabel ?? (_jsx(Text, { ...props.value, elmId: elmId ? `${elmId}-value` : 'value', className: cx('value', `value-${level}`, classNames.value), children: value }))] }));
};
export default LabelValue;
//# sourceMappingURL=index.js.map